import React from 'react'
import styled from 'styled-components'

const OrderStyle = styled.div`
    .ship-outside {
        padding: 240px 15px 50px; 


        @media (max-width: 1199px){
            padding: 210px 15px 0;
        }

        @media (max-width: 991px){
            padding: 180px 15px 0;        
        }

        @media (max-width: 767px){
            padding: 110px 15px 0;
        }

        .cstm-container {
            max-width: 1040px;
            padding: 0 15px;
            display: block;
            margin: auto;
        }
        .ship-outside-content {
            @media only screen and (max-width:1199px) {
                background: #cfd7dbd6;
                padding: 20px 10px;
            }

            p, ul li {
                font-size: 25px;
                line-height: 1.2;

                @media only screen and (max-width:1500px) {
                    font-size: 22px;
                }

                @media only screen and (max-width:1280px) {
                    font-size: 20px;
                }

                @media only screen and (max-width:767px) {
                    font-size: 18px;
                }

                &:not(:last-child) {
                    margin-bottom: 16px;
                }
            }

            ul {
                padding-left: 24px;

                @media only screen and (max-width:1280px) {
                    padding-left: 20px;
                }

                li {
                    /* list-style: none; */

                    &:not(:first-child,:nth-child(2)) {
                        list-style: disc;
                    }

                    &:not(:last-child) {
                        margin-bottom: 10px;
                    }
                }
            }
        }
    }
`
const index = () => {
    return (
        <OrderStyle>
            <div className='ship-outside' >
                <div className="cstm-container">
                    <div className="ship-outside-content">
                        <p className='international-orders'>We ship DNA test kits and customized supplements to the U.S. and and Canada. If you live in any of the countries
                            listed below, your customized supplement must be formulated through <a href="https://www.snipnutrition.com/dna-data-entry/">DNA data entry</a> (requires results from
                            companies such as 23andMe or Ancestry.com). </p>
                        <ul>
                            <li>UK</li>
                            <li>Australia</li>
                            <li>Germany</li>
                            <li>Denmark</li>
                            <li>Finland</li>
                            <li>Netherlands</li>
                            <li>Sweden</li>
                            <li>Ireland</li>
                        </ul>
                        <p className='international-orders'>If you have any questions, or live in a country not listed here and are interested in purchasing DNA-precision
                            nutrition from SNiP, please message us at <a href="mailto:support@snipnutrition.com">support@snipnutrition.com</a>
                        </p>
                    </div>
                </div>
            </div>
        </OrderStyle>
    )
}

export default index